var React = require('react');

function Layers (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M41 13.8934L21 26.7868L1 13.8934L21 1L41 13.8934Z","stroke":"#D22128","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M35.4975 17.4468L41 21.0001L21 33.8935L1 21.0001L6.52284 17.4468","stroke":"#D22128","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M35.4975 24.5532L41 28.1065L21 40.9999L1 28.1065L6.52284 24.5532","stroke":"#D22128","strokeMiterlimit":"10","key":2})]);
}

Layers.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Layers;

Layers.default = Layers;
